import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const WhatIsFaceYoga = lazyWithPreload(() => import('./WhatIsFaceYoga'))
